import { Route, Routes } from 'react-router-dom';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { Details } from './components/Details';
import { List } from './components/List';

export function NotificationsPage(): React.ReactElement {
  return (
    <DefaultLayout withHeader isNested>
      <Routes>
        <Route index element={<List />} />

        <Route path=":id" element={<Details />} />
      </Routes>
    </DefaultLayout>
  );
}
